package com.catbit.opinionpoll.inputs.providers

import androidx.compose.runtime.staticCompositionLocalOf
import com.catbit.opinionpoll.inputs.InputComposer

val LocalInputComposerProvider = staticCompositionLocalOf<InputComposer> {
    error("FormComposer not provided")
}